import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {AuthService} from '../../../../core/services';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'kt-forgot-password',
    templateUrl: './forgot-password.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
    form: FormGroup;

    loading = false;

    errors: any = [];

    notices = [];

    private unsubscribe: Subject<null>;

    sent = false;

    loginType: "order-go" | "suumo" = "order-go";

    constructor(
        private activatedRoute: ActivatedRoute,
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private cdr: ChangeDetectorRef) {
        this.unsubscribe = new Subject();
    }

    ngOnInit(): void {
        this.initForm();

        this.activatedRoute.queryParams.subscribe((params) => {
            if (params?.loginType === "suumo") {
                this.loginType === "suumo";
            }
        })
    }

    ngOnDestroy(): void {
        this.unsubscribe.next(null);
        this.unsubscribe.complete();
        this.loading = false;
    }

    initForm() {
        this.form = this.formBuilder.group({
            email: ['', Validators.compose([
                Validators.required,
                Validators.email,
                Validators.minLength(3),
                Validators.maxLength(320)
            ])],
        });
    }

    submit() {
        const controls = this.form.controls;
        if (this.form.invalid) {
            Object.keys(controls).forEach(controlName => {
                controls[controlName].markAsTouched();
            });
            this.cdr.detectChanges();
            return;
        }

        this.loading = true;
        this.authService.makeChangePasswordTrial(controls.email.value).subscribe((_) => {
            this.loading = false;
            this.sent = true;
            this.cdr.detectChanges();
        });
    }

    isControlHasError(validationType: string): boolean {
        const control = this.form.controls.email;
        if (!control) {
            return false;
        }
        return control.errors && control.errors[validationType] && control.dirty && control.touched;
    }
}

